'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pathToArr = exports.pathToArr = function pathToArr(path) {
  return path ? path.split(/\//).filter(function (p) {
    return !!p;
  }) : [];
};

var getSlashStrPath = exports.getSlashStrPath = function getSlashStrPath(path) {
  return pathToArr(path).join('/');
};

var getDotStrPath = exports.getDotStrPath = function getDotStrPath(path) {
  return pathToArr(path).join('.');
};

var combineReducers = exports.combineReducers = function combineReducers(reducers) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    return Object.keys(reducers).reduce(function (nextState, key) {
      nextState[key] = reducers[key](state[key], action);
      return nextState;
    }, {});
  };
};

var getFirestorePath = exports.getFirestorePath = function getFirestorePath(action) {
  if (!action.meta) {
    throw new Error('Meta is required to create firestore path');
  }
  var _action$meta = action.meta,
      collection = _action$meta.collection,
      doc = _action$meta.doc;

  return doc ? collection + '/' + doc : collection;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-firestore/es/utils/reducers.js
// module id = 188
// module chunks = 1